/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { useLocationGroupStore } from '@frontend/scope';
import { createNamespacedWetagHooks, createNamespacedWetagHooksForOrg } from '@frontend/wetags';
import type { AnalyticsTags } from './tags';

const useGetCurrentLocationId = () => {
  const locationId = useLocationGroupStore((state) => state.selectedLocationIds[0] || '');
  return locationId;
};

const ANALYTICS_NAMESPACE = 'analytics';

export const AnalyticsWetags = createNamespacedWetagHooks<AnalyticsTags>(ANALYTICS_NAMESPACE, useGetCurrentLocationId);

export const AnalyticsOrgWeTags = createNamespacedWetagHooksForOrg<AnalyticsTags>(ANALYTICS_NAMESPACE);
